var React = require('react');

function AtSign (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","transform":"translate(1 1)"},[React.createElement("circle",{"cx":"8.381","cy":"7.619","r":"3.048","key":0}),React.createElement("path",{"d":"M11.429 4.571v3.81a2.286 2.286 0 0 0 4.571 0v-.762a7.619 7.619 0 1 0-2.987 6.05","key":1})]));
}

AtSign.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = AtSign;

AtSign.default = AtSign;
